// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__RglB7","detailsBorder":"styles_detailsBorder__1EhDA"};